import {Component, OnInit, ElementRef, ViewChild, Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {Meta, DomSanitizer, Title} from '@angular/platform-browser';
import {FoEventsService} from "./foevents.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Ticket} from "../booking/ticket";
import {Order} from "../booking/order";
import {BooKingservice} from "../booking/booking.service";
import {BookingList} from "./bookingList";
import {ContactFormModalComponent} from "../contact-form-modal/contact-form-modal.component";
import {AuthService} from "../../core/auth/auth.service";
import {WINDOW, LOCAL_STORAGE} from '@ng-toolkit/universal';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {FonctionUtiles} from "../fonctionsUtiles";
import {ShareService} from "ngx-sharebuttons";
import {Pricing} from "../booking/pricing";

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css'],
  providers: [FoEventsService, BooKingservice]
})


export class EventComponent implements OnInit {
  id: number;
  isFrame = false;
  countdownStoped = false;
  event: any;
  ticketNumber: number = 0;
  pricings: Pricing[];
  pricingGroups: any;
  dayname: string;
  hours: any;
  day: any;
  month: any;
  jackpotdaysremain
  nbreTicket: number = 0;
  Total: any = 0;
  geocoder: any;
  latitude: any;
  longitude: any;
  positions: any[] = [];
  tickets: Ticket[] = [];
  bookingLists: BookingList[] = [];
  nbTicketArray = [];
  openPricePurpose = [];
  order: Order;
  diffdays: any;
  diffhour: any;
  diffminutes: any;
  datenow: any;
  organisaion: any;
  isEnd: boolean = false; // event start date past
  isClosed: boolean = false; // event closed date past => online ticketing end date
  selected: any = 'map';
  readMore: boolean = true;
  copyDisabled: boolean = false;
  galery: any;
  isSecret: boolean = false;
  password: string;
  unlockPassworderror: boolean = false;
  objectiveRate: number = 0;
  navigationSubscription;
  devise: any;
  front_event:any;
  daysarray: any = [];
  monthsarray: any = [];
  smartUrlId: string;
  ticketingsType:any = [];
  pricingsAndPrincingsInGroup:any;
  hasCodePromoClicked:boolean = false;
  codePrmo:any = "";
  codePromosActivated :any = [];
  eventCodePRomos:any=[];
  startJackpot :boolean = false;
  secretInputIsPassword: boolean = true;
  showMessages:boolean = false;
  fbBtn:any;
  url:string;

  /*initialiseInvites() {
    console.log('init');
    this.positions=[];
    this.ngOnInit()
  }*/

  setDevises(event) {
    if (event.currency) {
      this.devise = event.currency
    }
    else {
      this.devise = 'Eur'
    }
  }


  sanitizeHtml(html) {
     return  this.sanitized.bypassSecurityTrustHtml(html);
  }


  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  @ViewChild('contactFormModal') contactFormModal: ContactFormModalComponent;

  loadTranslations() {
    this.translateService.get('front_event').subscribe(
      value => {
        this.front_event = value;
        this.daysarray = value.daysarray.split(',');
        this.monthsarray = value.months.split(',');
      /*  console.log('pricing header  '+value);*/
      }
    )
  }

  constructor(
   // private readonly meta: MetaService,
    private sanitized: DomSanitizer,
    @Inject(WINDOW) private window: Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
  //  private readonly metas: MetaService,
    private eventservice: FoEventsService,
    private route: ActivatedRoute,
    private router: Router,
    private bookingservice: BooKingservice,
    private elRef: ElementRef,
    /*private fb: FacebookService,*/
    private authService: AuthService,
    private translateService: TranslateService,
    public functionUtils: FonctionUtiles,
    private title: Title,private shareService :ShareService) {
    /*this.navigationSubscription = this.router.events.subscribe((e: any) => {
       if (e instanceof NavigationEnd) {
         this.initialiseInvites();
       }
     });*/
    this.bookingservice.store('embeded',false);

    for (let i = 0; i <= 25; i++)
      this.nbTicketArray.push(i);

    // copy btn
    if (isPlatformBrowser(this.platformId))
      this.copyDisabled = !document.queryCommandSupported('copy');

    // fb init
   /* let initParams: InitParams = {
      appId: Helper.fbAppId(),
      xfbml: true,
      version: 'v2.10'
    };*/

    // fb init
   /* fb.init(initParams);*/

    // route param
    this.route.paramMap.subscribe(params => {
      if (params.has('id'))
        this.id = +params.get('id');
    });

    // countdown TODO #MEDIUM: is really working here ?  event is not yet init? Put in function initCountdwon()
    if (isPlatformBrowser(this.platformId))
      this.initCountdwon();

    console.log("constructor end");
  }

  shareOnSocial() {}

  ngOnInit() {
    this.bookingservice.store('embeded',false);
    this.url = window.location.href;
    this.initEventTicketingType();
    this.loadTranslations();
    this.initAll();
    this.saveEventVisit();
    this.initOpenPricePurpose();
   // this.initwfmShareMeta();
   // this.initTwitterShareMetas();
    /*if(this.userIsPreaccount) {
      this.authService.logoutWithoutRedirect();
    }*/
  }

  initOpenPricePurpose() {
    this.openPricePurpose.push({'value':0});
    this.openPricePurpose.push({'value':10});
    this.openPricePurpose.push({'value':30});
    this.openPricePurpose.push({'value':40});
    this.openPricePurpose.push({'value':60});
    this.openPricePurpose.push({'value':100});

    let url_string = window.location.href;
    let url = new URL(url_string);
    if (url_string.indexOf("inscriptions") == -1) {
      console.log('not inscription')
      this.bookingservice.removeItem('inscriptionIframe');
      this.bookingservice.removeItem('embededMode');
      this.bookingservice.removeItem('isInscription');
    }
  }

  formatEvents(res) {
    for (let i=0;i<res.length;i++) {
      res[i].has_ticketing = parseInt(res[i].has_ticketing);
    }
    return res;
  }

  initEventStartDate() {
    let debut = (this.event.start_date + ' ' + this.event.start_hour);
     return new Date(debut.replace(/ /g, "T"));
  }

  initEventEndDate() {
    let closed = (this.event.end_date + ' ' + this.event.end_hour)
    return  new Date(closed.replace(/ /g, "T"));
  }

  initAll() {
    //console.clear();
    if (isPlatformBrowser(this.platformId) && localStorage != undefined) {
      let url_string = window.location.href;
      let url = new URL(url_string);
      //let urlID = url.searchParams.get("from");
      this.smartUrlId = url.searchParams.get("from");
    }
    this.getGalery();
    this.getEvent().then(event => {
        this.setDevises(this.event);
        this.getPricing().then(res => {
          this.getPricingGroup().then(res => {
            this.concatPricings();
            this.retriveCodeActivatedFromStorageAndPlyPricing();
          });
        });
      this.router.events.subscribe(value => {
        this.title.setTitle(this.buildMetaDesc());
      });
      this.title.setTitle(this.buildMetaDesc());
      /*if (isPlatformBrowser(this.platformId))*/
      document.title = this.buildMetaDesc();
      console.log("get event then");
      /*if (isPlatformBrowser(this.platformId))*/
         document.title = this.buildMetaDesc();
        this.objectiveRate = (this.event.objectiveState / this.event.objective) * 100;
         if(this.event.password && this.event.is_visible == 3) {
            this.isSecret = true;
      }
      // meta tags for sharing
      this.initSharingMetas();
      this.codeAddress();
      let days = this.daysarray;
      let months = this.monthsarray;
      let d = this.initEventStartDate();
      this.dayname = days[d.getDay()];
      this.hours = d.getHours();
      this.day = d.getDate();
      this.month = months[d.getMonth()];
       this.getDate().then(any => {
        let c = new Date();
        let dcountdownEnd = this.initEventStartDate();
        let dClosed = this.initEventEndDate();
         let timeDiff1 =  dClosed.getTime() - c.getTime();
         this.jackpotdaysremain = (timeDiff1 - timeDiff1 % (1000 * 3600 * 24)) / (1000 * 3600 * 24);
        if (dClosed.getTime() - c.getTime() <= 0) this.isEnd = true;
        if (dcountdownEnd.getTime() - c.getTime() <= 0) this.countdownStoped = true;
        if (dClosed.getTime() - c.getTime() <= 0) this.isClosed = true;
        if (!this.countdownStoped) {
         this.setCountDownValues(dcountdownEnd,c);
        }
      });
      this.getOrganisation();
      console.log("get event then end");
    });
    console.log("init end");
  }

  videoURL() {
    return this.sanitized.bypassSecurityTrustUrl(this.event.videoSrc);
  }

  initCountdwon() {
    setInterval(() => {
      this.getDate().then(any => {
      /*  let date1 = new Date(this.datenow.date.replace(/ /g, "T"));*/
        let c = new Date();
        // console.log(this.datenow);
        if (this.event) {
          let dcountdownEnd = this.initEventStartDate();
          let dta = this.initEventEndDate();
          let date2 = new Date(dta);
          if (date2.getTime() - c.getTime() <= 0) this.isEnd = true;
          // event ticketing closed
          //stop countdown
          if (dcountdownEnd.getTime() - c.getTime() <= 0) this.countdownStoped = true;
          if (date2.getTime() - c.getTime() <= 0) this.isClosed = true;
          if (!this.countdownStoped) {
            this.setCountDownValues(dcountdownEnd,c);
          }
        }
      })
    }, 1000 * 60);
  }

  setCountDownValues(dcountdownEnd,c) {
    let timeDiff =  dcountdownEnd.getTime() - c.getTime();
    this.diffdays = (timeDiff - timeDiff % (1000 * 3600 * 24)) / (1000 * 3600 * 24);
    let diffHours = (timeDiff - this.diffdays * 1000 * 3600 * 24);
    this.diffhour = (diffHours - diffHours % (1000 * 3600)) / (1000 * 3600);
    let diffMinutes = (timeDiff - this.diffhour * 1000 * 3600 - this.diffdays * 1000 * 3600 * 24);
    this.diffminutes = (diffMinutes - diffMinutes % (1000 * 60)) / (1000 * 60);
  }


  callback(event) {
    console.log("hey");
  }

  nl2br(str) {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
  }

  formatPricing(pricings) {
    for(let i = 0; i < pricings.length; i++) {
      if(pricings[i].is_visible)
        this.ticketNumber++;
        pricings[i].Totalplace = parseInt(pricings[i].Totalplace);
        pricings[i].description = this.nl2br(pricings[i].description)
        pricings[i].nbreTicket = 0;
        if(new Date(pricings[i].openDate.replace(/ /g, "T")).getTime() > new Date().getTime()) {
           pricings[i].IsComing = true;
        }
        if(pricings[i].endDate && new Date(pricings[i].endDate.replace(/ /g, "T")).getTime() < new Date().getTime())
          pricings[i].IsClosed = true;
        if(!pricings[i].devise) {
        if(this.event.currency) {
          pricings[i].devise = this.event.currency
        } else {
          pricings[i].devise = 'Eur'
        }
      }

      if(pricings[i].selectable_q)  {
         pricings[i]['pricingSelectableArray'] = [];
         for (let m = 0; m < pricings[i].selectable_q+1; m++)
           pricings[i].pricingSelectableArray.push(m);
      }
    }
    return pricings;
  }
  getPricingPrice(pricing) {
    return this.functionUtils.getPricingPrice(pricing);
  }

  getEventDesc() {
    if(this.event.desc)
      return this.event.desc.replace(/(<([^>]+)>)/ig,"").substring(0,160);
    else  return '';
  }

    initwfmShareMeta() {
     /* this.meta.setTitle(this.event.name);
      this.meta.setTag('og:url', this.router.url);
      this.meta.setTag('og:type', 'article');
      this.meta.setTag('og:image',Helper.asset(this.event.image));
      this.meta.setTag('og:description', this.buildMetaDesc()+' '+this.getEventDesc());*/
      /*this.meta.updateTag({name: 'og:url', content: this.router.url});
      this.meta.updateTag({name: 'og:type', content: 'article'});
      this.meta.updateTag({name: 'og:image', content: Helper.asset(this.event.image)});
      this.meta.updateTag({name: 'og:description', content: this.buildMetaDesc()+' '+this.getEventDesc()});*/
    }

  initFacebookSharingMetas(): void {
    console.log('initing fb sharing meta new yuman');
    // meta tags for fb
    //this.initwfmShareMeta();
    let $ = window['jQuery'];
    $('#facebookShare').click();
  }

  initWhatsappSharingMetas(): void {
    console.log('initing fb sharing meta');
    // meta tags for fb
    //this.initwfmShareMeta();
    let $ = window['jQuery'];
    $('#whatsappShare').click();
  }

  initMessengerSharingMetas(): void {
    console.log('initing fb sharing meta');
    // meta tags for fb
    //this.initwfmShareMeta();
    let $ = window['jQuery'];
    $('#messengerShare').click();
  }
  initTwitterShareMetas() {
    /*this.meta.setTitle(this.event.name);
    this.meta.setTag('twitter:description', this.buildMetaDesc());
    this.meta.setTag('twitter:image',  Helper.asset(this.event.image));
    this.meta.setTag('twitter:card', 'summary_large_image');*/
  }

  initTwitterSharingMetas(): void {
    console.log('initing twitter  sharing meta');
    let $ = window['jQuery'];
    $('#twitterShare').click();
  }

  initSharingMetas(): void {
    // meta tags for twitter
  /*  // meta fb
     this.meta.updateTag(this.event.name);
     this.meta.updateTag(name:'og:title', this.event.name);
     this.meta.updateTag('og:url', this.router.url);
     this.meta.updateTag('og:type', 'article');
     this.meta.updateTag('og:image', Helper.asset(this.event.image));
     this.meta.updateTag('og:description', this.buildMetaDesc());*/

  }

  buildMetaDesc(): string {
    // TODO put back this.buildDate() in share msg
    return this.event.name + ' - ' + this.event.location_name +
      ' ' + this.front_event.book_on_akces_your_market_place
  }

  buildDate(): string {
    return this.dayname + ' ' + this.day + ' ' + this.month;
  }

  buildShareMsg(): string {
    // TODO put back this.buildDate() in share msg
    return this.event.name + ' - ' + this.event.location_name +
      ' ' + this.front_event.book_on_akces_your_market_place + ': ' + this.router.url;
  }

  buildLink(encoded?: boolean): string {
    if (!encoded) return this.router.url;
    return encodeURIComponent(this.router.url);
  }

  copyLink() {
    // tried
    // https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
    // https://developers.google.com/web/updates/2015/04/cut-and-copy-commands
    if (isPlatformBrowser(this.platformId)) {
      let textArea = document.createElement("textarea");


      //
      // *** This styling is an extra step which is likely not required. ***
      //
      // Why is it here? To ensure:
      // 1. the element is able to have focus and selection.
      // 2. if element was to flash render it has minimal visual impact.
      // 3. less flakyness with selection and copying which **might** occur if
      //    the textarea element is not visible.
      //
      // The likelihood is the element won't even render, not even a flash,
      // so some of these are just precautions. However in IE the element
      // is visible whilst the popup box asking the user for permission for
      // the web page to copy to the clipboard.
      //
      // Place in top-left corner of screen regardless of scroll position.
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = '0';
      // Clean up any borders.
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      // Avoid flash of white box if rendered for any reason.
      textArea.style.background = 'transparent';
      textArea.value = this.event.smartUrl ? this.event.smartUrl : this.router.url;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    }
    // return to avoid default event
    return false;
  }


  /*shareFB() {

    // prepare
    let params: UIParams = {
      href: this.router.url,
      method: 'share'
    };

    // cal
    this.fb.ui(params)
      .then((res: UIResponse) => console.log(res))
      .catch((e: any) => console.error(e));
    // return to avoid default event
    return false;

  }*/



  changeListener($event, prcings): void {
    this.eventCodePRomos = this.event.codepromos.slice(0);
    this.Total = 0;
    this.nbreTicket = 0;
    for (let i = 0; i < prcings.length; i++) {
      if(this.getPricingPrice(prcings[i]) >=0 && prcings[i].nbreTicket > 0 ) {
       // console.log(prcings[i]);
       /* if(prcings[i].codePromo)
        {
          if (!prcings[i].open)
            this.Total += prcings[i].nbreTicket  * this.getPricingPrice(prcings[i]) - this.CodePRomoReduction(prcings[i]);
          else
            this.Total +=  this.getPricingPrice(prcings[i]) - this.CodePRomoReduction(prcings[i]);
        }
        else*/
          if (!prcings[i].open) {

               this.Total += prcings[i].nbreTicket * this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
            //initialiser les tarifs libre à zero et laisser le choix a l'utilisateur quand il s'agit d'une cagnotte
            if(this.event.has_open_ticketing && prcings[i].nbreTicket > 0) {
               this.initOpenPricings(prcings);
            }
          }
          else {
            prcings[i].nbreTicket = 0;
            this.Total += prcings[i].nbreTicket * this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
           }
            this.nbreTicket += prcings[i].nbreTicket;
          }
       }
     }


  changeopenPricingsListener($event, prcings): void {
    this.eventCodePRomos = this.event.codepromos.slice(0);
    this.Total = 0;
    this.nbreTicket = 0;
    for (let i = 0; i < prcings.length; i++) {
      if(this.getPricingPrice(prcings[i]) >=0 && prcings[i].nbreTicket >= 0 ) {
        //console.log(prcings[i]);
        /* if(prcings[i].codePromo)
         {
           if (!prcings[i].open)
             this.Total += prcings[i].nbreTicket  * this.getPricingPrice(prcings[i]) - this.CodePRomoReduction(prcings[i]);
           else
             this.Total +=  this.getPricingPrice(prcings[i]) - this.CodePRomoReduction(prcings[i]);
         }
         else*/
        if (!prcings[i].open) {
          this.Total += prcings[i].nbreTicket * this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
        }
        else {
          prcings[i].nbreTicket = 1;
          this.Total += prcings[i].nbreTicket * this.getPricingPrice(prcings[i]) - this.pricingReduction(prcings[i]) - this.orderReductionByPricing(prcings[i]);
        }
        this.nbreTicket += prcings[i].nbreTicket;
      }
    }
  }

     unactivatePricingsPurpose() {
       for (let i = 0; i < this.openPricePurpose.length; i++) {
           this.openPricePurpose[i]['active'] = false;
         }
       }


     initOpenPricings(prcings) {
       this.unactivatePricingsPurpose();
       for (let i = 0; i < prcings.length; i++) {
         if (prcings[i].open) {
              prcings[i].nbreTicket = 0;
              prcings[i].price = this.openPricePurpose[0].value;
              this.openPricePurpose[0]['active'] = true;
          }
        }
     }

  codePromoReduct(pricing) {
    if(pricing.codePromo && pricing.codePromo.reduction_simple )
      return  parseFloat(pricing.codePromo.reduction_simple);
    else if(pricing.codePromo && pricing.codePromo.reduction_by_percentage )
      return (this.getPricingPrice(pricing)* parseFloat(pricing.codePromo.reduction_by_percentage)/100);
    else if(pricing.codePromo && pricing.codePromo.reduction_type == "Gratuit")
      return this.getPricingPrice(pricing);
    else
      return 0;
  }


  pricingReduction(pricing) {
    //console.log(pricing);
    let reduction:number = 0;
    reduction += this.codePromoReduct(pricing);

    if(pricing.codePromo && pricing.codePromo.can_be_used_several_times) {
      return reduction * pricing.nbreTicket;
    } else {
      return reduction;
    }

  }

  orderReductionByPricing(pricing) {
    let reduction:number = 0;
    if(this.eventCodePRomos) {
      //répartir toutes les promostions lié a la commande sur chaque tarif quand il s'agit d'une reduction en pourcentage
      //s'il s'agit d'une reduction simple on reduit le premier tarif en une fois
      for(let i = 0; i < this.eventCodePRomos.length; i++) {
        if(this.eventCodePRomos[i].reduction_simple ) {
          //répartir les reduction sur toutes les tickets

          if(pricing.codePromo && pricing.codePromo.can_be_used_several_times) {
            reduction += this.eventCodePRomos[i].reduction_simple/this.functionUtils.calculSelectedPricingNumber(this.pricingsAndPrincingsInGroup) * pricing.nbreTicket;
          } else {
            reduction += this.eventCodePRomos[i].reduction_simple/this.functionUtils.calculSelectedPricingNumber(this.pricingsAndPrincingsInGroup);
          }

          //console.log(this.functionUtils.calculSelectedPricingNumber(this.pricingsAndPrincingsInGroup));
        }
        else {
          // percentengage reduction on total order is sum of all pricing total percentage reduction
          reduction += (this.getPricingPrice(pricing) * this.eventCodePRomos[i].reduction_by_percentage * pricing.nbreTicket)/100;
        }
      }
    }
    return reduction;
  }


  orderReductionByTicket(pricing) {
    let reduction:number = 0;
    if(this.eventCodePRomos) {
      //répartir toutes les promostions lié a la commande sur chaque tarif quand il s'agit d'une reduction en pourcentage
      //s'il s'agit d'une reduction simple on reduit le premier tarif en une fois
      for(let i = 0; i < this.eventCodePRomos.length; i++) {
        if(this.eventCodePRomos[i].reduction_simple ) {
          //répartir les reduction sur toutes les tickets
          reduction += this.eventCodePRomos[i].reduction_simple/this.functionUtils.calculTicketsSelectedNumber(this.pricingsAndPrincingsInGroup);
        } else {
          // percentengage reduction on total order is sum of all pricing total percentage reduction
          reduction += (this.getPricingPrice(pricing) * this.eventCodePRomos[i].reduction_by_percentage)/100;
        }
      }
    }
    return reduction;
  }


  getEvent(): Promise<any> {
    return this.eventservice.event(this.id).then(event => {
     /* console.log(event)*/
      event.has_ticketing = parseInt(event.has_ticketing);
      event.children = this.formatEvents(event.children);
      event['codepromos'] = [];
      //event.start_date=moment(event.start_date).format('DD-MM-YYYY')
      this.event = event
    });
  }

  getVal(value) {
    if(value)
      return value;
    else
      return ' ';
  }

  location() {
    return this.event.adresse + ' ' + this.getVal(this.event.zipcode) + ' ' + this.getVal(this.event.city) + ' ' + this.getVal(this.event.country);
  }

  hasLocation(){
    return this.event.adresse && this.event.zipcode && this.event.city && this.event.country;
  }

  location1() {
    return ' ' + this.getVal(this.event.zipcode) + ' ' + this.getVal(this.event.city) + ' ' + this.getVal(this.event.country);
  }

  slugify(string) {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }

  getPricing(): Promise<any> {
    return this.eventservice.pricing(this.id).then(pricings => {
      console.log(pricings);
      this.pricings = this.formatPricing(pricings);
      this.pricingsAndPrincingsInGroup =  this.formatPricing(pricings.slice(0));
      //console.log(this.pricingsAndPrincingsInGroup  +'groups aaa')
      //console.log(this.pricings)
    });
  }

  concatPricings() {

  }

  setOpenPricingDefault(pricings,event){
    if(event.has_open_ticketing) {
      for(let i=0;i<pricings.length;i++) {
        if(pricings[i].open)
          this.purposeOpenprice(this.openPricePurpose[3],pricings[i]);
      }
    }
  }

  getPricingGroup(): Promise<any> {
    return this.eventservice.pricingGroupList(this.id).then(groups => {
      this.pricingGroups = groups;
      // this.pricinngs=pricings
      for (let i = 0; i < this.pricingGroups.length; i++) {
        this.pricingGroups[i].pricings = this.formatPricing(this.pricingGroups[i].pricings);
      }

      //get all pricings and pricings in groups to pass it to total calcul total ...
      for (let i = 0; i < this.pricingGroups.length; i++) {
        for (let j = 0; j < this.pricingGroups[i].pricings.length; j++) {
          this.pricingsAndPrincingsInGroup.push(this.pricingGroups[i].pricings[j])
        }
      }
      //console.log(groups)
    });
  }


  getGalery(): Promise<any> {
    return this.eventservice.galery(this.id).then(galery => {
      this.galery = galery
     // console.log(galery)
    });
  }

  getDate(): Promise<any> {
    return this.eventservice.date().then(any => {
      this.datenow = any
      console.log(this.datenow)
    });
  }

  getOrganisation(): Promise<any> {
    return this.eventservice.organisation(this.id).then(any => {
      if (any != 'not found') {
        this.organisaion = any;
        //console.log(any)
      }
     // console.log(this.organisaion)
    });
  }




  checkExhausted(pricing) {
    if (pricing.Totalplace <= '0' && pricing.Totalplace != -1 && pricing.ShowNbPlace) {
      return 'ticket-purpose alert-danger flexible line-though'
    }
    else {
      return 'bg-white ticket-purpose  flexible';
    }
  }

  event_has_Booking(event) {
    return event.has_ticketing || event.has_open_ticketing || event.has_registration_module;
  }

  nbPlace(pricing) {

    if (pricing.Totalplace && pricing.Totalplace > 0 && pricing.ShowNbPlace) {
      return pricing.Totalplace + ' ' + this.front_event.remainings_tickets;
    }
    else if (pricing.Totalplace && pricing.Totalplace == 0 && pricing.ShowNbPlace) {
      return this.front_event.sold_out;
    }
    else if (pricing.Totalplace == -1 && pricing.ShowNbPlace) {
      return this.front_event.unlimited_number_of_place;
    }
  }

  /* event_is_free():any
  {
      return this.pricing.is_free
  }*/

  codeAddress(): Promise<any> {

    if(this.hasLocation()){
      this.eventservice.getLocation(this.location()).then(any => {
          //console.log(any.results[0].geometry.location)
          this.latitude = any.results[0].geometry.location.lat;
          this.longitude = any.results[0].geometry.location.lng;
          let pos = {lat: this.latitude, lng: this.longitude};
          this.positions.push(pos);
        }
      );
    }
    /*this.geocoder.geocode({'address': this.event.location_name}, (results, status) => {
      this.latitude=results[0].geometry.location.lat();
      this.longitude=results[0].geometry.location.lng();
      let pos = {lat: this.latitude, lng: this.longitude};
      this.positions.push(pos);
    });*/
    return;
  }

  addValueAttribute(res) {
    for(let i = 0; i < res.length; i++) {
      res[i]['value'] = '';
      res[i]['isValid'] = false;
      res[i]['touched'] = false;
    }
    return res;
  }

  //add props to inputs
  addvaluesToForm(form) {
    if(form && form.inputsTicket)
        this.addValueAttribute(form.inputsTicket)
    if(form && form.inputsOrder)
        this.addValueAttribute(form.inputsOrder);
    return form;
  }


  //check if input exist in array by label
  ExistInarray(arr1,string1) {
    for(let i=0;i<arr1.length;i++) {
      if(arr1[i].label == string1)
         return true;
    }
    return false;
  }

  //buyer inputs are sum all buyerinputs of all form
  addOtherOrderInputsToBuyerInputs(inputs ,form2) {
    if(form2 && form2.inputsOrder && inputs) {
      for(let i = 0; i < form2.inputsOrder.length; i++) {
        if(!this.ExistInarray(inputs,form2.inputsOrder[i].label)) {
          inputs.push(form2.inputsOrder[i]);
        }
      }
     }
   }



   //find form to add  to ticket
  getTicketForm(pricing) {
      if(pricing.form) {
        return this.addvaluesToForm(pricing.form);
      }
      else if(this.event.form) {
        return this.addvaluesToForm(this.event.form);
      }
      else {
        return this.addvaluesToForm(this.eventservice.DefaultForm());
      }
  }

  getUsedCodePromo() {
    let codes = [];
    for(let i = 0; i < this.pricingsAndPrincingsInGroup.length; i++) {
      if(this.pricingsAndPrincingsInGroup[i].nbreTicket>0 && this.pricingsAndPrincingsInGroup[i].codePromo )
        codes.push(this.pricingsAndPrincingsInGroup[i].codePromo)
    }

    for(let i=0 ; i <this.event.codepromos.length; i++) {
        codes.push(this.event.codepromos[i])
    }
    return codes;
  }

  // TODO #MEDIUM, translate in english next()
  poursuivre(pricings): Promise<any> {
    if(this.event.has_open_ticketing && !this.startJackpot) {
       this.startJackpot = true;
      this.setOpenPricingDefault(this.pricingsAndPrincingsInGroup,this.event);
       return;
    }
    console.log('ok');
    //this.retriveCodeActivatedFromStorageAndPlyPricing();
    if (this.pricingGroups) {
      for (let i = 0; i < this.pricingGroups.length; i++) {
        for (let j = 0; j < this.pricingGroups[i].pricings.length; j++) {
          pricings.push(this.pricingGroups[i].pricings[j])
        }
      }
    }

    if (this.nbreTicket == 0) {
        alert(this.front_event.enter_number_of_ticket);
       return;
    }

    for (let i = 0; i < pricings.length; i++) {

        if (pricings[i].Totalplace < pricings[i].nbreTicket && pricings[i].Totalplace != -1) {
           alert(this.front_event.your_order_more_ticket_than_available + ' ' + pricings[i].label);
           return;
         }
      /*if (pricings[i].open && pricings[i].price < 1) {
           alert(this.front_event.the_jackpot_must_be_more_than_1);
          return;
         }*/
     }

    this.order = new Order();
    this.order.total_price = this.Total.toFixed(2);
    this.order.event_id = this.event.id;
    this.order.date = this.event.date;
    this.order.smart_urlID = this.smartUrlId;
    this.order.codepromos = this.getUsedCodePromo();
    //event date or datenow?
    /*  for (let i=0; i<this.nbreTicket; i++) {
        let  ticket =new Ticket();
        ticket.pricing_id=this.pricing.id;
        ticket.event_id=this.id;
        ticket.id=i+1;
        this.tickets.push(ticket);
      }*/
    let id = 1;
    for (let i = 0; i < pricings.length; i++) {
      let booking = new BookingList();
      booking.Pricing_label = pricings[i].label;
      let t = [];
      if(pricings[i].codePromo && pricings[i].codePromo.reduction_type == "Gratuit") {
        //fist ticket ispromo true
        let ticket = new Ticket();
        ticket.pricing_id = pricings[i].id;
        ticket.event_id = this.id;
        ticket.id = id;
        ticket.pricing_label = pricings[i].label;
        ticket.isPromo = true;
        ticket.form = this.getTicketForm(pricings[i]);
        //concat buyer inputs
        this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
        id ++;
        t.push(ticket);

        for(let j = 0; j < (pricings[i].nbreTicket-1); j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          //répartir la reduction promo du tarif sur tous les ticktes du tarifs
          //ticket.reduction += this.pricingReduction(pricings[i])/(pricings[i].nbreTicket-1);
          //ajouter la part de reduction de commande correspondant au ticket
          ticket.reduction += this.orderReductionByTicket(pricings[i]);
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
        }
      }
      else {
        for (let j = 0; j < pricings[i].nbreTicket; j++) {
          let ticket = new Ticket();
          ticket.pricing_id = pricings[i].id;
          ticket.event_id = this.id;
          ticket.id = id;
          ticket.pricing_label = pricings[i].label;
          //répartir la reduction promo du tarif sur tous les ticktes du tarifs
          ticket.reduction += this.pricingReduction(pricings[i])/pricings[i].nbreTicket;
          //ajouter la part de reduction de commande correspondant au ticket
          ticket.reduction += this.orderReductionByTicket(pricings[i]);
          //set form on ticket
          ticket.form = this.getTicketForm(pricings[i]);
          //concat buyer inputs
          this.addOtherOrderInputsToBuyerInputs(this.order.Buyerinputs,ticket.form);
          id ++;
          t.push(ticket);
        }
      }

          //promotion pricing group
      if (pricings[i].type == 'groupe' && pricings[i].nb_of_participants > 1) {
          let nombre = pricings[i].nbreTicket * pricings[i].nb_of_participants - pricings[i].nbreTicket;
          for (let k = 0; k < nombre; k++) {
           let ticket = new Ticket();
           ticket.pricing_id = pricings[i].id;
           ticket.event_id = this.id;
           ticket.isPromo = true;
           ticket.id = id;
           ticket.pricing_label = pricings[i].label;
            ticket.form = this.getTicketForm(pricings[i]);
            id ++;
           t.push(ticket);
          }
       }
        booking.tickets = t;
       if(booking.tickets.length>0) {
          this.bookingLists.push(booking);
         }
       }

      //let sessionExpirationTime = new Date().getTime() +15*1000;
      this.bookingservice.store('order', this.order);
      this.bookingservice.store('bookingList', this.bookingLists);
      this.bookingservice.store('pricings', this.pricingsAndPrincingsInGroup);
      this.bookingservice.store('event', this.event);
      this.bookingservice.store('organisation', this.getOrganiser());
      this.bookingservice.store('result', this.order);
      this.bookingservice.store('book','notDone');
      this.bookingservice.store('sessionExpirationTime',this.bookingExpirationTime());
      this.bookingservice.store('currenteventUrl',window.location.href);
      this.bookingservice.store('codePromosActivated',this.codePromosActivated);
      this.router.navigate(['/booking/infos']);
      return;
  }
  getOrganiser(){
    //console.log(this.event.user.organisation.name);
    if(this.event.user.organisation && this.event.user.organisation.name && this.event.user.organisation.id != 2) {
      return this.event.user.organisation
    } else {
      return 'Organisation'
    }
  }

  minutesToMs(min) {
    return min * 60 * 1000;
  }

  bookingExpirationTime() {
    if(this.event.booking_expiration)
      return this.minutesToMs(this.event.booking_expiration);
    else
      return this.minutesToMs(10);
  }

  toggle1(event): Promise<any> {
    this.selected = 'map';
    return;
  }

  toggle2(event): Promise<any> {
    this.selected = 'galerie';
    return;
  }

  isDraft() {
    return parseInt(this.event.is_published) === 0;
  }


  isDraftCls() {
    return this.isDraft() ? "event-reservation--overlay" : "";
  }

  unlockSecretEvent() {
    this.eventservice.unLock({'password': this.password, 'event_id': this.id}).then(any => {
        if (any == 'unlocked') {
          this.isSecret = false;
        }
        else {
          this.unlockPassworderror = true;
        }
      }
    )
  }

  openContactModal() {
    this.contactFormModal.showModal();
  }


  getPrice(pricing) {
    /*if(pricing.commission =='Impacter_sur_le_prix_de_vente_final')
    {

    }*/
    return pricing.price;
  }


  getUser() {
    return this.authService.getUser();
  }


  checkEventVisibility() {
    if (parseInt(this.event.is_published) == 0) {
      return (this.getUser().id && this.getUser().role_id && ((this.event.user_id == this.getUser().id) || this.getUser().role_id == 1))
    }
    else {
      return true;
    }
  }

  planExtension() {
    let $ = window['jQuery'];
    $('#planExtension').modal('show');
  }

  showPassword() {
    let $ = window['jQuery'];
    let passwordInput =  $('#myPasswordInput');
    if (passwordInput.attr('type') === "password") {
      this.secretInputIsPassword = false;
      passwordInput.attr('type', 'text');
    } else {
      passwordInput.attr('type', 'password');
      this.secretInputIsPassword = true;
    }
  }



  getTicketingType(event) {
    if(event.has_ticketing)
      return this.ticketingsType[0];
    else if(event.has_registration_module)
      return this.ticketingsType[1];
    else
      return this.ticketingsType[2];
  }

  initEventTicketingType () {

    this.ticketingsType = [{
        title: 'home.buy',
        label: 'home.buy',
        class:''
      }, {
        title: 'S\'inscrire',
        label: 'S\'inscrire',
        class:''
      }, {
        title: 'home.see',
        label: 'home.see',
        class: 'btn-grey'
      }
    ]
  }

  saveEventVisit() {
    return  this.eventservice.saveEventVisit({'event_id': this.id}).then(any => {
        console.log('visit saved')
      }
    )
  }

  changeHasCodePromo() {
    this.hasCodePromoClicked =! this.hasCodePromoClicked;
  }


  findPricingAndApplycode(code) {
    if(code.pricing) {
      for(let i=0; i<this.pricings.length; i++) {
        if(this.pricings[i].id == code.pricing.id)
          this.pricings[i]['codePromo'] = code;
      }

      for(let i=0; i<this.pricingsAndPrincingsInGroup.length; i++) {
        if(this.pricingsAndPrincingsInGroup[i].id == code.pricing.id)
          this.pricingsAndPrincingsInGroup[i]['codePromo'] = code;
      }
      //console.log(this.pricingsAndPrincingsInGroup)
    }
  }

  ApplycodePRomoToEvents(code) {
    this.event.codepromos.push(Object.assign({},code));
  }

  checkIfCodealreadyApplied(code) {
    if(this.bookingservice.retrieve('codePromosActivated')) {
      this.codePromosActivated = this.bookingservice.retrieve('codePromosActivated');
      for(let i=0;i<this.codePromosActivated.length;i++) {
        if(this.codePromosActivated[i].id == code.id)
        return true
      }
      return false;
    }
    return false;
  }

  price(price) {
    if(price == 0)
      return 'Gratuit';
    else
      return price.toFixed(2) +' '+this.functionUtils.getPricingDeviseSymbole(this.event.currency);
  }


  calculatePricingPriceAfterPromoApply(pricing) {
    if(pricing.codePromo && pricing.codePromo.reduction_simple )
     return this.getPricingPrice(pricing)  - pricing.codePromo.reduction_simple;
    else if(pricing.codePromo && pricing.codePromo.reduction_by_percentage )
      return this.getPricingPrice(pricing)  - (this.getPricingPrice(pricing)* pricing.codePromo.reduction_by_percentage/100);
    else if(pricing.codePromo && pricing.codePromo.reduction_type == "Gratuit")
      return 0;
    else
      return 0;
  }

  pricingIsToMuchSelected(pricing) {
    return (pricing.Totalplace < pricing.nbreTicket)&& (pricing.Totalplace!=-1)
  }


  applycodePromo(code?) {
      let $ = window['jQuery'];
     this.eventservice.checkEventCodePromo({'event_id': this.id,'code':this.codePrmo}).then(any => {
        this.hasCodePromoClicked = false;
        if(any != 'expired' && any != 'code_not_found' && any != 'limit') {
          this.codePrmo = null;
         /* console.log(any);*/
          if(!this.checkIfCodealreadyApplied(any)) {
            this.codePromosActivated.push(any);
            this.bookingservice.store('codePromosActivated',this.codePromosActivated);
            if(any.pricing) {
              //apply only code promo on pricigs
              this.findPricingAndApplycode(any);
            }
            else {
              this.ApplycodePRomoToEvents(any);
            }

            if(this.Total>0) {
              console.log('codePromo changing');
              this.changeListener('',this.pricingsAndPrincingsInGroup);
              $('.pricing-selection').trigger('change');
            }
          } else {
            if(!parseInt(any.can_be_used_several_times)) {
              this.translateService.get("front_event.the_code_can_only_be_used_once_per_order").subscribe(res => {
                alert(res);
                return;
              })
            }
          }
        }
        else if(any == 'limit') {
          this.translateService.get("front_event.number_of_uses_limit_reached").subscribe(res => {
            alert(res);
            return;
          })
        }
        else {
          this.translateService.get("front_event.code_promo_expired_or_dont_exist").subscribe(res => {
            alert(res);
            return;
          })
        }
      }
    )
  }

  cleanCodePromos() {
    for(let i = 0; i < this.pricingsAndPrincingsInGroup.length;i++) {
      this.pricingsAndPrincingsInGroup[i].codePromo = null;
    }
    this.event.codepromos = [];
  }

  getOnlyEventCodePRomo(codes) {
   let eventcodes = [];
    for(let i = 0; i < codes.length; i++) {
      if(codes[i].event_id === this.event.id) {
        eventcodes.push(codes[i])
      }
    }
    return eventcodes;
  }


  // when code Promo activated add code PRomo column to pricings in order to hanle changes
  retriveCodeActivatedFromStorageAndPlyPricing() {
    this.cleanCodePromos();
    if(this.bookingservice.retrieve('codePromosActivated')) {
     // this.codePromosActivated = this.getOnlyEventCodePRomo(this.bookingservice.retrieve('codePromosActivated'));
      for(let i = 0; i < this.codePromosActivated.length; i++) {
        if(this.codePromosActivated[i].event_id === this.event.id) {
        if(this.codePromosActivated[i].pricing) {
          this.findPricingAndApplycode(this.codePromosActivated[i]);
        } else {
         /* console.log(this.codePromosActivated[i]);*/
          this.ApplycodePRomoToEvents(this.codePromosActivated[i]);
        }
        }
      }
    }
  }

  deleteCodePRomo(code) {
    this.codePromosActivated.splice(code,1);
    this.bookingservice.store('codePromosActivated',this.codePromosActivated);
    this.retriveCodeActivatedFromStorageAndPlyPricing();
    this.changeListener('',this.pricingsAndPrincingsInGroup)
    //window.location.reload();
  }

  eventIsjackpot(event) {
    return parseInt(event.has_open_ticketing);
  }

  showValue(val) {
    if(val == null)
      return 0;
    return val;
  }

  purposeOpenprice(item, pricing) {
    pricing.price = item.value;
    this.removeAllPurposeActive(this.openPricePurpose);
    item['active'] = true;
    pricing.nbreTicket = 1;
    this.changeopenPricingsListener('',this.pricingsAndPrincingsInGroup);
/*    console.log(pricing)*/
    //return;
  }

  removeAllPurposeActive(items) {
    for(let i = 0; i < items.length; i++) {
      items[i]['active'] = false;
    }
  }

  eventIsOnline(event) {
    return event.onlineLocationChoice === 'evenemet_en_ligne';
  }

  eventNotHaveLocation(event) {
    return event.onlineLocationChoice === 'a_venir';
  }

  userIsPreaccount() {
    return this.authService.loggedIn() && this.authService.getUser() && this.authService.getUser().isPreAccount
  }

}
